import React, { useEffect, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { ListItemText } from "@material-ui/core";
import { useParams } from "react-router";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { httpPost } from "../../../../../../../Utils/apis/apis";
import { epochToDateFormatHelper } from "../../../../../../../Utils/Helpers/dateUtils";
import selectedIcon from "./Icon.helpers";
import * as previousUploadActions from "../../../../../../../store/actions/previousUploadActions";
import * as previousUploadDeleteActions from "../../../../../../../store/actions/previousUploadDeleteActions";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import M_ActionGroup from "../../../ActionGroup/M_ActionGroup";
import { sortFiles } from "../../../../../../Factory/Molecules/Common/Renderers/Views/PreviousTemplate/previousUpload.helper";
import LoaderSkeleton from "../../../LoaderSkeleton";
import { executeJSString } from "../../../../../Pages/Common/Layouts/layout.Helper";
import { getObjectFromJSONString } from "../../../Navigations/AddEntity/M_ManageEntityForm.helper";
import { getSubDomain } from "../../../../../Pages/Common/User Management/HelperFunctions";

const useStyles = makeStyles(() => ({
  CustomCard: {
    maxHeight: "52vh",
    overflow: "scroll",
    overflowX: "hidden",
  },
  list: {
    borderBottom: "1px solid lightgrey",
    "&:hover": {
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
    },
  },
  avatar: {
    margin: "auto",
    paddingLeft: "10px",
  },
  heading: {
    marginTop: "10px",
  },
  ActionGroup: {
    paddingTop: "25px",
  },
  ListFlex: {
    display: "flex",
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: "none",
  },
}));

const PreviousUploads = (props) => {
  const classes = useStyles();
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let { templateId, crmId, pageUrl } = useParams();
  const [disabledItems, setDisabledItems] = useState([]);
  useEffect(() => {
    if (props.previousUpload.data) {
      let sortElements = props.previousUpload.data;
      sortElements = sortFiles(sortElements, "fileDisplayName");
      setReports(sortElements);
      setIsLoading(false);
    }
  }, [props.previousUpload]);

  useEffect(() => {
    props.previousUpload.data = undefined;
    props.getPreviousUpload({
      crmId: crmId,
      pageUrl:
        props.content.fileName == undefined ? pageUrl : props.content.fileName,
      container: props.content && props.content.containerType,
      directory: props.content && props.content.directory,
    });
    setReports([]);
  }, [templateId]);

  const handleDataChange = () => {
    setTimeout(() => {
      props.getPreviousUpload({
        crmId: crmId,
        pageUrl:
          props.content.fileName == undefined
            ? pageUrl
            : props.content.fileName,
        container: props.content && props.content.containerType,
        directory: props.content && props.content.directory,
      });
      props.delfile();
    }, 1000);
  };

  const handelDelete = async (e) => {
    const docName = e;
    const fileOp = "delete";
    await props.getPreviousUploadDelete({
      documentName: docName,
      fileOperation: fileOp,
      containerType: props.content && props.content.containerType,
    });
  };

  const handleClick = async (e, index) => {
    // Disable the specific item
    setDisabledItems((prevDisabledItems) => {
      const updatedDisabledItems = [...prevDisabledItems];
      updatedDisabledItems[index] = true;
      return updatedDisabledItems;
    });
    //TODO - refactor it. Use saga for async behavior.
    const documentName = e.file;
    const url = `${process.env.DOCUMENT_HELPER}`;
    const subdomain = getSubDomain();
    let header = {
      filename: documentName,
      type:
        props.content && props.content.containerType
          ? props.content.containerType
          : "generic",
      "file-operation": "download",
      "process-file": "yes",
      "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
      subdomain: subdomain,
    };
    httpPost(
      url,
      {
        method: "GET",
      },
      { responseType: "blob", headers: header }
    ).then((response) => {
      const url1 = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url1;
      link.setAttribute("download", e.fileDisplayName);
      document.body.appendChild(link);
      link.click();
      //Enabling specific item
      setDisabledItems((prevDisabledItems) => {
        const updatedDisabledItems = [...prevDisabledItems];
        updatedDisabledItems[index] = false;
        return updatedDisabledItems;
      });
    });
  };
  var documentName = _.get(props, "content.name");

  return (
    <>
      {documentName ? (
        <div className={classes.heading}>
          <h5>{documentName} </h5>
        </div>
      ) : (
        ""
      )}

      <div className={classes.CustomCard}>
        {/* TODO - correct logic as per new implementation (saga) */}
        {isLoading ? (
          <LoaderSkeleton />
        ) : reports && reports.length > 0 ? (
          reports.map((item, index) => (
            <ListItem key={index} className={classes.list}>
              <Grid container spacing={2}>
                <Grid xs={11}>
                  <List
                    button
                    onClick={() => handleClick(item, index)}
                    className={`${classes.ListFlex} ${
                      disabledItems[index] ? classes.disabled : ""
                    }`}
                  >
                    <ListItemAvatar className={classes.avatar}>
                      <Avatar
                        src={selectedIcon(item.fileDisplayName)}
                        variant="square"
                      />
                    </ListItemAvatar>

                    <ListItem alignItems="flex-start">
                      <ListItemText
                        primary={item.fileDisplayName}
                        secondary={
                          "Uploaded on " +
                          epochToDateFormatHelper(
                            item.modifiedTime || item.creationTime,
                            getObjectFromJSONString(
                              props,
                              ".content.dateFormat"
                            ) || "DD-MM-YYYY"
                          )
                        }
                      />
                    </ListItem>
                  </List>
                </Grid>
                {props.currentPage &&
                props.currentPage.pageConfig &&
                props.currentPage.pageConfig.pageSecurity &&
                props.currentPage.pageConfig.pageSecurity.Full === true &&
                executeJSString(
                  getObjectFromJSONString(props, ".content.readOnlyTemplate"),
                  getObjectFromJSONString(props, ".currentPage.data")
                ) != true ? (
                  <Grid xs={1} className={classes.ActionGroup}>
                    <div>
                      <M_ActionGroup
                        delete={props.content.delete}
                        onDelete={() => handelDelete(item.file)}
                        handleDataChange={() => handleDataChange()}
                        modify={true}
                      />
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </ListItem>
          ))
        ) : (
          ""
        )}
      </div>
    </>
  );
};
PreviousUploads.propTypes = {
  previousUpload: PropTypes.any,
  getPreviousUpload: PropTypes.any,
  getPreviousUploadDelete: PropTypes.any,
  delfile: PropTypes.func,
  currentPage: PropTypes.any,
  content: PropTypes.any,
};

function mapStateToProps(state) {
  return {
    previousUpload: state.previousUpload,
    previousUploadDelete: state.previousUploadDelete,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign({}, previousUploadActions, previousUploadDeleteActions),
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviousUploads);
